import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next'; // Import useTranslation


// Replace this with your project's actual Blink Lightning Address

function PayPal() {
    const [payPalLoading, setPayPalLoading] = useState(true);

    const { t, i18n } = useTranslation(); // Initialize useTranslation
    
  //   useEffect(() => {
  //   // Load PayPal script
  //   const script = document.createElement('script');
  //   script.src = "https://www.paypal.com/sdk/js?client-id=BAAMvjEIfegC4Hn1NnlNzAODTYoPSkHxLpghP5vupHXOMih-lc1fpzSDipd00IsHqjE8a6VbRyoHbbBZDg&components=hosted-buttons&disable-funding=venmo&currency=EUR";
  //   script.async = true;
  //   script.onload = () => {
  //     if (window.paypal) {
  //       window.paypal.HostedButtons({
  //         hostedButtonId: "54ZN7L8GK7SX8"
  //       }).render("#paypal-container-54ZN7L8GK7SX8").then(() => {
  //           setPayPalLoading(false);
  //       })
  //     }
  //   };
  //   document.body.appendChild(script);

  //   // Cleanup: remove script if component unmounts
  //   return () => {
  //     // Ensure script is still a child of body before removing
  //     if (script.parentNode === document.body) {
  //       document.body.removeChild(script);
  //     }
  //   };
  // }, []);

  useEffect(() => {
      if (!document.getElementById("paypal-sdk")) {
        const script = document.createElement('script');
        script.id = "paypal-sdk";
        script.src = "https://www.paypal.com/sdk/js?client-id=BAAMvjEIfegC4Hn1NnlNzAODTYoPSkHxLpghP5vupHXOMih-lc1fpzSDipd00IsHqjE8a6VbRyoHbbBZDg&components=hosted-buttons&disable-funding=venmo&currency=EUR";
        script.async = true;
        script.onload = () => {
          if (window.paypal && window.paypal.HostedButtons) {
            window.paypal.HostedButtons({
              hostedButtonId: "54ZN7L8GK7SX8"
            }).render("#paypal-container-54ZN7L8GK7SX8").then(() => {
              setPayPalLoading(false);
            });
          }
        };
        document.body.appendChild(script);
      } else {
        // Script already loaded, just render the button
        if (window.paypal && window.paypal.HostedButtons) {
          window.paypal.HostedButtons({
            hostedButtonId: "54ZN7L8GK7SX8"
          }).render("#paypal-container-54ZN7L8GK7SX8").then(() => {
            setPayPalLoading(false);
          });
        }
      }
    }, []);

  return (
    <>
      <div className="paypal-section" >
        <h2>{t("spendings.header.paypal")}</h2>
        {payPalLoading && (
          <div style={{ margin: "2rem", display:"flex", justifyContent:"center"}}>
            <i className="fas fa-spinner fa-spin" style={{ fontSize: "2rem" }}></i>
          </div>
        )}
        <div id="paypal-container-54ZN7L8GK7SX8" style={{ display: payPalLoading ? "none" : "block", marginTop:"50px"}}></div>
      </div>
    </>
  );
}

export default PayPal;